import { Component, Injector, OnInit } from '@angular/core';
import { ComponentService } from '../../../shared/abstract/component.service';
import { RequestService } from '../../../shared/services/request.service';
import { PoiCategoryRegionFilterModel } from '../../../shared/model/poi-category-region-filter-model';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { ActionType } from '../../../shared/enum/actionType';
import { ManagementType } from '../../../shared/enum/managementType';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../../../shared/widgets/modal/modal.component';
import { debounceTime } from 'rxjs/operators';

interface SearchParams {
  searchTerm: string;
  columnName?: string;
}

@Component({
  selector: 'app-poi-category-region-management',
  templateUrl: './poi-category-region-management.component.html',
  styleUrl: './poi-category-region-management.component.css',
})
export class PoiCategoryRegionManagementComponent
  extends ComponentService<any>
  implements OnInit
{
  dataSource = new MatTableDataSource<any>();
  currentCompany;
  poiCategoryRegionSearchLength;

  pageIndex = 0;
  pageSize = 5;
  currentPage = 0;
  totalPages = 0;
  maxVisibleButtons = 5;
  Math = Math;

  propertiesForColumn: any[] = [];
  searchValuesForColumn: any[] = [];

  isSideNavOpen = false;
  selectedManagementType!: ManagementType;
  selectedActionType!: ActionType;

  ManagementType = ManagementType;
  ActionType = ActionType;

  inputValues: { [key: string]: string } = {};
  searchInput: string = '';
  private searchSubject: Subject<SearchParams> = new Subject();
  
  isProcessedFilter: boolean | null = null;

  displayedColumns = ['companyId', 'projectId', 'cityId', 'districtId', 'neighbourhoodId', 'isProcessed', 'options'];
  selectedPoiCategoryRegion?: any;

  constructor(
    private _request: RequestService,
    injector: Injector,
    private _dialog: MatDialog
  ) {
    super(injector);

    this.searchSubject.pipe(debounceTime(600)).subscribe((searchParam) => {
      this.filter(searchParam.searchTerm, searchParam.columnName);
    });
  }

  ngOnInit(): void {
    if (
      this._appsService?.existCurrentProject?.companyId &&
      this._appsService?.existCurrentProject?.projectId
    ) {
      this.currentProject = this._appsService.existCurrentProject;
      this.currentCompany = this._appsService.existCurrentCompany;
      this.managementConfig();
    }

    this.cPSubs = this._appsService.currentProject.subscribe((project) => {
      this.currentProject = project;
      this.currentCompany = this._appsService.existCurrentCompany;
      this.managementConfig();
    });
  }

  managementConfig() {
    this.getPaginatedQuery();
  }

  getPaginatedQuery() {
    let model: PoiCategoryRegionFilterModel = new PoiCategoryRegionFilterModel();

    model.propertyNames = this.propertiesForColumn;
    model.searchValues = this.searchValuesForColumn;
    model.and = true;
    model.orderColumn = '';
    model.order = 'desc';
    model.index = this.pageIndex;
    model.size = this.pageSize;
    model.isProcessed = this.isProcessedFilter;

    this._request
      .getPaginatePoiCategoryRegionInfos(model)
      .then((result) => {
        if (result && result.items) {
          this.dataSource.data = result.items;
          this.poiCategoryRegionSearchLength = result.count || 0;
        } else {
          this.dataSource.data = [];
          this.poiCategoryRegionSearchLength = 0;
        }
      })
      .catch((err) => {
        this.dataSource.data = [];
        this.poiCategoryRegionSearchLength = 0;
        this.MessageBox('Hata oluştu: ' + err, 'warn', 'center');
      })
      .finally(() => {
        this.updateTotalPages();
      });
  }

  onIsProcessedFilterChange(value: boolean | null) {
    this.isProcessedFilter = value;
    this.currentPage = 0;
    this.pageIndex = 0;
    this.getPaginatedQuery();
  }

  onInputChange(event: Event, columnName?: string): void {
    const inputElement = event.target as HTMLInputElement;
    const searchTerm = inputElement.value;
    this.searchSubject.next({ searchTerm, columnName });
  }

  filter(searchTerm: string, columnName?: string): void {
    if (columnName) {
      var propertyIndex = this.propertiesForColumn.indexOf(columnName);
      if (propertyIndex != -1)
        if (searchTerm == '' || searchTerm == null || searchTerm == undefined) {
          this.propertiesForColumn.splice(propertyIndex, 1);
          this.searchValuesForColumn.splice(propertyIndex, 1);
        } else this.searchValuesForColumn[propertyIndex] = searchTerm;
      else {
        this.propertiesForColumn.push(columnName);
        var newPropertyIndex = this.propertiesForColumn.indexOf(columnName);
        this.searchValuesForColumn[newPropertyIndex] = searchTerm;
      }
    }

    this.currentPage = 0;
    this.pageIndex = 0;

    this.getPaginatedQuery();
  }

  get visiblePageNumbers(): number[] {
    const start = Math.max(
      0,
      Math.min(
        this.currentPage - Math.floor(this.maxVisibleButtons / 2),
        this.totalPages - this.maxVisibleButtons
      )
    );
    return Array.from(
      { length: Math.min(this.maxVisibleButtons, this.totalPages) },
      (_, i) => start + i + 1
    );
  }

  onPageChange(pageIndex: number) {
    if (pageIndex >= 0 && pageIndex < this.totalPages) {
      this.currentPage = pageIndex;
    }
    this.pageIndex = pageIndex;
    this.getPaginatedQuery();
  }

  updatePageSize(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    this.pageSize = parseInt(selectElement.value, 10);
    this.updateTotalPages();
    this.currentPage = 0;
    this.pageIndex = 0;
    this.getPaginatedQuery();
  }

  updateTotalPages() {
    this.totalPages = Math.ceil(this.poiCategoryRegionSearchLength / this.pageSize);
  }

  deletePoiCategoryRegion(element) {
    const dialogRef = this._dialog.open(ModalComponent, {
      width: '400px',
      data: {
        type: 'confirm',
        title: 'deletePoiCategoryRegion',
        body: 'deletePoiCategoryRegionConfirm',
        ok: 'confirm',
        cancel: 'cancel',
        color: 'warn',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this._request
          .deletePoiCategoryRegionInfo(
            element.companyId,
            element.projectId,
            element.cityId,
            element.districtId,
            element.neighbourhoodId
          )
          .then((res) => {
              if(res == true){
                this.MessageBox(this.languageKey('deleteSuccess'), 'primary', 'center');
              } else {
              this.MessageBox(this.languageKey('deleteFailed'), 'warn', 'center');
            }
          })
          .catch((err) => {
            this.MessageBox(
              this.languageKey('unexpectedError'),
              'warn',
              'center'
            );
          })
          .finally(() => {
            this.getPaginatedQuery();
          });
      }
    });
  }

  async openSideNav(
    managementType: ManagementType,
    actionType: ActionType,
    selectedPoiCategoryRegion?: any
  ) {
    this.selectedManagementType = managementType;
    this.selectedActionType = actionType;
    
    if (actionType === ActionType.Update && selectedPoiCategoryRegion) {
      try {
        const companyId = selectedPoiCategoryRegion.companyId;
        const projectId = selectedPoiCategoryRegion.projectId;
        const cityId = selectedPoiCategoryRegion.cityId;
        const districtId = selectedPoiCategoryRegion.districtId || null;
        const neighbourhoodId = selectedPoiCategoryRegion.neighbourhoodId || null;
        
        const latestData = await this._request.getPoiCategoryRegionInfoById(
          companyId,
          projectId,
          cityId,
          districtId,
          neighbourhoodId
        );
        
        this.selectedPoiCategoryRegion = latestData;
      } catch (error) {
        this.selectedPoiCategoryRegion = selectedPoiCategoryRegion;
      }
    } else {
      this.selectedPoiCategoryRegion = selectedPoiCategoryRegion;
    }
    
    this.isSideNavOpen = true;
  }
}
